import { makeDataStatusFetch } from './_shared/fetchMakers';
import { makeDataStatusUrl } from './_shared/urlMakers';

export const fetchDataStatus = makeDataStatusFetch(makeDataStatusUrl);
